// extracted by mini-css-extract-plugin
export default {"movie-list-section":"MovieList_movie-list-section__kibDo"};